import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { IBookingListResponse, IDashboardMumResponse, IDashboardMidwifeResponse, 
  IReviewResponse, ITestimonialResponse, IBookingRequestResponse, INotificationListResponse, ICreateAppointmentResponse, IAppointmentListResponse, IBookingUpdateResponse } from '../models/dashboard.models';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient,
              private authService: AuthService) { }

  getDashboardMidwife(body: any): Observable<IDashboardMidwifeResponse> {
    const token = this.authService.token;
    const url = `${environment.serverUrl}midwife/dashboard`;
    if(token == undefined){
      throw new Error('Token is not present');
    }
    
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IDashboardMidwifeResponse>(url, body, httpOptions);
  }

  getDashboardMum(body: any): Observable<IDashboardMumResponse>{
    const token = this.authService.token;
    const url = `${environment.serverUrl}mum/dashboard`;
    if(token == undefined){
      throw new Error('Token is not present');
    }
    
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IDashboardMumResponse>(url, body, httpOptions);
  }

  getMidwifeById(id: number): Observable<IDashboardMidwifeResponse>{
    const url = `${environment.serverUrl}midwife/getbyid`;
    let body={
      midwifeId: id
    }
    return this.http.post<IDashboardMidwifeResponse>(url, body);
  }

  getMumById(id: number): Observable<IDashboardMumResponse>{
    const url = `${environment.serverUrl}mum/getbyid`;
    let body={
      mumId: id
    }
    return this.http.post<IDashboardMumResponse>(url, body);
  }

  createTestimonial(body: any): Observable<ITestimonialResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}testimonial/create`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<ITestimonialResponse>(url, body, httpOptions);
  }
  
  createReview(body: any): Observable<IReviewResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}review/create`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IReviewResponse>(url, body, httpOptions);
  }
  
  addIntro(body: any): Observable<IDashboardMidwifeResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}midwife/addintro`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IDashboardMidwifeResponse>(url, body, httpOptions);
  }

  getNotificationsMidwife(body: any): Observable<INotificationListResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}notification/list`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<INotificationListResponse>(url, body, httpOptions);
  }

  getNotificationsMum(body: any): Observable<INotificationListResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}notification/listformum`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<INotificationListResponse>(url, body, httpOptions);
  }

  getAllBookingMum(): Observable<IBookingListResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}booking/listrequestsformum`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.get<IBookingListResponse>(url, httpOptions);
  }

  declineBookingRequest(body: any): Observable<IBookingRequestResponse>{
    const token = this.authService.token;
    const url = `${environment.serverUrl}booking/denyrequest`;
    if(token == undefined){
      throw new Error('Token is not present');
    }
    
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IBookingRequestResponse>(url, body, httpOptions);
  }

  createBookingRequest(body: any): Observable<IBookingRequestResponse>{
    const token = this.authService.token;
    const url = `${environment.serverUrl}booking/createrequest`;
    if(token == undefined){
      throw new Error('Token is not present');
    }
    
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IBookingRequestResponse>(url, body, httpOptions);
  }

  createAppointmentRequest(body: any): Observable<ICreateAppointmentResponse>{
    const token = this.authService.token;
    const url = `${environment.serverUrl}appointment/create`;
    if(token == undefined){
      throw new Error('Token is not present');
    }
    
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<ICreateAppointmentResponse>(url, body, httpOptions);
  }

  getAppointmentListByMonth(body: any): Observable<IAppointmentListResponse>{
    const token = this.authService.token;
    const url = `${environment.serverUrl}midwife/calendarbymonth`;
    if(token == undefined){
      throw new Error('Token is not present');
    }
    
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IAppointmentListResponse>(url, body, httpOptions);
  }

  approveBookingReqandBook(body: any): Observable<IBookingRequestResponse>{
    const token = this.authService.token;
    const url = `${environment.serverUrl}booking/approverequestandbook`;
    if(token == undefined){
      throw new Error('Token is not present');
    }
    
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IBookingRequestResponse>(url, body, httpOptions);
  }

  updateBookingDates(body: any): Observable<IBookingUpdateResponse>{
    const token = this.authService.token;
    const url = `${environment.serverUrl}booking/update`;
    if(token == undefined){
      throw new Error('Token is not present');
    }
    
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IBookingUpdateResponse>(url, body, httpOptions);
  }
}
